export const VerifiedAnimation = (
  <svg
    width="61"
    height="61"
    viewBox="0 0 412 412"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color: "var(--YW_SignIn_Modal_SuccessfulLogin_Color)" }}
  >
    {/* Circle */}
    <circle
      cx="206"
      cy="206"
      r="195"
      transform="rotate(90 206 206)"
      stroke="currentColor"
      strokeWidth="22"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="90 206 206"
        to="450 206 206"
        dur="0.75s"
        fill="freeze"
      />
    </circle>

    {/* Checkmark Path */}
    <path
      d="M87.9257 226.5L152.382 286.234L322.926 112"
      stroke="currentColor"
      strokeWidth="22"
      strokeOpacity="0"
    >
      <animate
        attributeName="stroke-opacity"
        values="0;0.25;0.5;0.75;1"
        keyTimes="0;0.25;0.5;0.75;1"
        dur="0.75s"
        fill="freeze"
      />
    </path>
  </svg>
);
